
import React from "react";
import { Menu } from "lucide-react";
import { cn } from "@/lib/utils";
import SidebarLogo from "./SidebarLogo";
import SidebarNavigation from "./SidebarNavigation";
import HelpSection from "./HelpSection";
import { NavItem } from "./types";

interface DesktopSidebarProps {
  navItems: NavItem[];
  isCollapsed: boolean;
  toggleSidebar: () => void;
  className?: string;
}

const DesktopSidebar: React.FC<DesktopSidebarProps> = ({ 
  navItems, 
  isCollapsed, 
  toggleSidebar, 
  className 
}) => {
  return (
    <aside
      className={cn(
        "fixed top-0 left-0 z-30 h-full transition-all duration-300 ease-in-out hidden lg:block",
        isCollapsed ? "w-16" : "w-64",
        className
      )}
    >
      <div className="h-full flex flex-col bg-card border-r shadow-sm">
        <div className={cn("flex items-center p-4", isCollapsed ? "justify-center" : "justify-between")}>
          <SidebarLogo isCollapsed={isCollapsed} />
          <button
            onClick={toggleSidebar}
            className={cn("p-1.5 rounded-lg bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700", 
              isCollapsed ? "mx-auto mt-2" : "")}
            aria-label="Toggle sidebar"
          >
            <Menu size={20} className="text-gray-500 dark:text-gray-400" />
          </button>
        </div>

        <SidebarNavigation navItems={navItems} isCollapsed={isCollapsed} />

        <div className="p-4 mt-auto">
          <HelpSection isCollapsed={isCollapsed} />
        </div>
      </div>
    </aside>
  );
};

export default DesktopSidebar;
